import React from "react";
import DynamicTable from "../../Table/index";
import Icon from "../../../icons";
import Avatar from "react-avatar";
import useOrganizationAccess from "./useOrganizationAccess";
import AddUserModal from "./AddUserModal";
import RemoveUserModal from "./RemoveUserModal";

const OrganizationAccess = (props) => {
  const {
    hasOrgUsers,
    listLoaded,
    handleAddUserClick,
    handleRemoveUserClick,
    showAddUserModal,
    closeAddUserModal,
    searchAddableUsers,
    searchLoading,
    handleSearchUserOnChange,
    filteredOrgUsersList,
    searchText,
    toggleSortByName,
    provideOrgAccess,
    removeOrgUserAccess,
    showRemoveUserModal,
    setShowRemoveUserModal,
    searchedUsers,
  } = useOrganizationAccess();

  // ✅ Dynamic columns
  const columns = [
    {
      key: "name",
      header: "Name",
      showFilter: true,
      onFilterClick: toggleSortByName,
      headerClassName: "space-between",
      render: (row) => (
        <div className="userGroup pdNone">
          <div className="rowFlex">
            <div className="userPic userPicIcon">
              <Avatar
                round={true}
                size={props.size ? props.size : "32"}
                name={row.firstName + " " + row.lastName}
                maxInitials={2}
              />
            </div>

            <div className="userInfo colFlex">
              <span>
                {row.firstName} {row.lastName}
              </span>
            </div>
          </div>
        </div>
      ),
    },

    {
      key: "emailaddress",
      header: "Email Address",
      render: (row) => (
        <span>{row.email}</span>
      ),
    },
    {
      key: "action",
      header: "",
      className: "align-right",
      render: (row) => (
        <button
          className="btn-cc__link btn-cc__link__red"
          onClick={() => handleRemoveUserClick(row.communityId, row.id)}
        >
          Remove
        </button>
      ),
    },
  ];

  const renderList = () => {
    if (!listLoaded) return null;
    if (!hasOrgUsers) {
      return (
        <div className="noDataFound">
          No user has access to your organization yet. Click "Add User" to provide access.
        </div>
      );
    }
    if (filteredOrgUsersList.length === 0) {
      return <div className="noDataFound">No users found.</div>;
    }
    return <DynamicTable columns={columns} data={filteredOrgUsersList} />;
  };
  return (
    <div className="colFlex admin__container__org_access">
      <div className="rowFlex alignMiddle rowSpaceBetween mb admin__container__org_access__header">
        <h1 className="alignMiddle rowFlex">Organization Access 
          <span className="quickTooltip-bottom quickTooltip medium white" data-quicktooltip="Authorize users from other organizations to access and search your organization's Workkards and Activities."><Icon name="info" className="icon greyInfoIcon ml" /></span></h1>

        <div className="org_access__add--user">
          <div className="formGroup mrNone">
            <div className="search rowFlex mr">
              <input
                type="search"
                placeholder="Search by email"
                value={searchText}
                onChange={(e) => {
                  handleSearchUserOnChange(e.target.value);
                }}
              />
              <div className="search__icon">
                <ul className="rowFlex">
                  <li>
                    {searchText ? (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleSearchUserOnChange("");
                        }}
                      >
                        <Icon name="close" className="icon iconSmall" />
                      </a>
                    ) : (
                      <a href="javascript:void(0)">
                        <Icon name="search" className="icon searchIcon" />
                      </a>
                    )}
                  </li>
                </ul>
              </div>
            </div>
            <input
              type="button"
              value="Add User"
              className="btn buttonGradient"
              onClick={handleAddUserClick}
            />
          </div>
        </div>
      </div>
      <div className="admin__container__data admin__container__data--org-access">
      {renderList()}
      {showAddUserModal && (
        <AddUserModal
          onCancelPress={closeAddUserModal}
          searchedUsers={searchedUsers}
          searchLoading={searchLoading}
          handleSearch={searchAddableUsers}
          onProvideAccess={provideOrgAccess}
        />
      )}
      {showRemoveUserModal && (
        <RemoveUserModal
          onCancelPress={() => setShowRemoveUserModal(false)}
          onHandleRemoveAccess={removeOrgUserAccess}
        />
      )}
      </div>
    </div>
  );
};

export default OrganizationAccess;
